import { Button, Spinner } from 'reactstrap';
import styles from './Favorite.module.scss';
import { useContext, useState, useRef } from 'react';
import { UserContext } from '../../../global/globalContext/context';
import { showMsg } from '../../../global/langs/langs';
import useApiPrivate from '../../../global/utils/hooks/useApiPrivate';
import { useEffect } from 'react';
import useAuth from '../../../global/utils/hooks/useAuth';
import { Toast } from 'primereact/toast';


const PRODUCT_FAVORITE = 'api/v1/user-favorites';

export default function Favorite({isOnlyIcon, productId}) {
    const { lang } = useContext(UserContext);
    const ApiPrivate = useApiPrivate();
    const {auth} = useAuth();
    const toast = useRef(null);


    const [favorite, setFavorite] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const showSuccess = (message) => {
        toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
    }
    const showError = (message) => {
        toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
    }

    const getFavoriteStatus = async () => {
        setIsLoading(true);
        await ApiPrivate.get(`${PRODUCT_FAVORITE}/${productId}`)
            .then(function(response){
                setIsLoading(false);
                setFavorite(response.data.data);
            })
            .catch (function(error){
                showError(error?.response?.data?.message)
            })
    }

    const toggleFavorite = async (event) => {
        event.preventDefault();

        setIsLoading(true);

        await ApiPrivate.put(`${PRODUCT_FAVORITE}?product_id=${productId}`)
            .then(function(response){
                setFavorite(response.data.data);
                setIsLoading(false);
                if(response.data.data){
                    showSuccess('Added to wishlist')
                } else {
                    showSuccess('Remove from wishlist')
                }
            })
            .catch(function(error){
                showError(error?.response?.data?.message)
            })
    }

    useEffect(() => {
        if (auth?.token){
            getFavoriteStatus();
        }
    },[])

  return (
    <>
        <div className='d-inline-block text-start'>
            <Toast ref={toast} position="top-center" />
        </div>
        <div className={`${styles.favorites} ${isOnlyIcon ? `position-absolute ${styles.isOnlyIcon}` : `text-center px-2 px-sm-4 my-3 d-inline-block ${styles.rightDivider}`} `}>
            <Button 
                className={`
                    ${styles.actionIcon} 
                    bg-transparent 
                    border-0
                    ${isOnlyIcon ? `p-0` : ``}
                    `}
                    disabled={isLoading ? true : false}
                onClick={(event) => toggleFavorite(event)}
                >
                    {
                        isLoading 
                        ? (
                        <>
                            <Spinner size="sm">
                            Loading...
                            </Spinner>
                        </>
                        )
                        : <i className={`
                                bi 
                                ${favorite ? 'bi-bookmark-fill' : 'bi-bookmark'}
                                ${favorite && styles.active}
                            `}>
                            </i>
                    }
            </Button>
            {
                !isOnlyIcon &&
                    <div className={`${styles.actionTitle} ${favorite && styles.active}`}>
                        {showMsg('wishlist', lang)}
                    </div>
            }
        </div>
    </>
  )
}
